"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M8.096 21.213A9.747 9.747 0 0 0 12 22a9.748 9.748 0 0 0 3.904-.787 10.09 10.09 0 0 0 3.173-2.136c.9-.9 1.611-1.957 2.136-3.173A9.748 9.748 0 0 0 22 12a9.747 9.747 0 0 0-.787-3.904 10.09 10.09 0 0 0-2.136-3.173 10.09 10.09 0 0 0-3.173-2.136A9.749 9.749 0 0 0 12 2a9.748 9.748 0 0 0-3.904.787 10.092 10.092 0 0 0-3.173 2.136c-.9.9-1.611 1.957-2.136 3.173A9.748 9.748 0 0 0 2 12c0 1.387.262 2.688.787 3.904a10.09 10.09 0 0 0 2.136 3.173c.9.9 1.957 1.611 3.173 2.136Zm4.917-9.435v5.26h-2.04v-6.601h1.271c.671 0 .77.223.77 1.341Zm.098-3.726c0 .6-.49 1.076-1.104 1.076-.615 0-1.118-.475-1.118-1.076 0-.601.503-1.09 1.118-1.09.615 0 1.104.489 1.104 1.09Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};